import _slicedToArray from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useConfig } from '@hummingbirdtechgroup/wings-config';
import { useState } from 'react';
import { getAuthenticatedUser, saveAuthenticatedUser } from '../utils';
import fetchUser from './fetchUser';

function useUser(id, token) {
  var config = useConfig();

  var _useState = useState(getAuthenticatedUser()),
      _useState2 = _slicedToArray(_useState, 2),
      user = _useState2[0],
      setUser = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var setStateData = function setStateData(newUser) {
    saveAuthenticatedUser(newUser);
    setUser(newUser);
    setLoading(false);
  };

  if (!loading && id && (!user || user.uid !== id)) {
    setLoading(true);
    fetchUser(id, config.apiUrl, token).then(function (result) {
      return setStateData(result);
    }).catch(function () {
      return setStateData(null);
    });
  }

  return {
    user: user,
    loading: loading
  };
}

export default useUser;